import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API_URL from "../../../../apiConfig";
import AdminHeader from "../../../../components/AdminHeader";
import AdminPageHeader from "../../../../components/admin/AdminPageHeader";
import apiFetch from "../../../../utils/apiFetch";

export default function AdminLessons() {

  const { systemId, sectionId } = useParams();

  const [lessons, setLessons] = useState([]);
  const [title, setTitle] = useState("");
  const [dayNumber, setDayNumber] = useState("");
  const [loading, setLoading] = useState(true);

  async function loadLessons() {
    try {

      const data = await apiFetch(`/api/systems/${systemId}/sections/${sectionId}/lessons`);
      setLessons(data.lessons || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadLessons();
  }, []);

  async function createLesson(e) {
    e.preventDefault();

    try {
      await apiFetch(`/api/systems/${systemId}/sections/${sectionId}/lessons`, {
        method: "POST",
        body: {
          day_number: Number(dayNumber),
          title
        },
      });

      setTitle("");
      setDayNumber("");

      loadLessons();
      
      } catch (err) {
    console.error(err);
    alert(err.message);
  }

  }

  async function removeLesson(id) {

    if (!window.confirm("¿Eliminar día?")) return;

    await apiFetch(`/api/systems/${systemId}/sections/${sectionId}/lessons/${id}`, {
      method: "DELETE",
    });

    loadLessons();
  }

  return (
    <>
      <AdminHeader />

      <div style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>

        <AdminPageHeader
          title="Lecciones (días)"
          subtitle="Gestionar los días del sistema."
          backTo={`/admin/systems/${systemId}/sections`}
        />

        {/* FORM */}
        <form onSubmit={createLesson} style={formBox}>

          <input
            type="number"
            placeholder="Número de día"
            value={dayNumber}
            onChange={(e) => setDayNumber(e.target.value)}
            required
            style={inputStyle}
          />

          <input
            placeholder="Título del día"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={inputStyle}
          />

          <button style={primaryBtn}>
            Crear día
          </button>

        </form>

        {/* LISTADO */}
        <div style={{ marginTop: 20, display: "grid", gap: 12 }}>

          {loading ? (
            <p style={{ color: "#6b7a88" }}>Cargando...</p>
          ) : lessons.length === 0 ? (
            <p style={{ color: "#6b7a88" }}>No hay días aún.</p>
          ) : (
            lessons.map((lesson) => (

              <div key={lesson.id} style={cardStyle}>

                <div>
                  <div style={dayTitle}>
                    Día {lesson.day_number}
                  </div>
                  <div style={lessonTitle}>
                    {lesson.title}
                  </div>
                </div>

                <div style={actionsStyle}>

                  <Link
                    to={`/admin/systems/${systemId}/sections/${sectionId}/lessons/${lesson.id}/items`}
                    style={linkStyle}
                  >
                    Contenido →
                  </Link>

                  <button
                    onClick={() => removeLesson(lesson.id)}
                    style={deleteBtn}
                  >
                    Eliminar
                  </button>

                </div>

              </div>

            ))
          )}

        </div>

      </div>
    </>
  );
}

/* ===== STYLES ===== */

const formBox = {
  display: "grid",
  gap: 10,
  padding: 20,
  borderRadius: 12,
  border: "1px solid #e6ebf1",
  background: "#fff",
  marginBottom: 20
};

const inputStyle = {
  padding: 10,
  borderRadius: 8,
  border: "1px solid #ddd"
};

const primaryBtn = {
  padding: "10px 14px",
  background: "#0a2230",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600
};

const cardStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: 14,
  borderRadius: 10,
  border: "1px solid #e6ebf1",
  background: "#fff"
};

const dayTitle = {
  fontWeight: 700
};

const lessonTitle = {
  fontSize: 13,
  color: "#6b7a88",
  marginTop: 2
};

const actionsStyle = {
  display: "flex",
  gap: 10,
  alignItems: "center"
};

const linkStyle = {
  textDecoration: "none",
  color: "#264763",
  fontWeight: 600
};

const deleteBtn = {
  border: "1px solid #ddd",
  padding: "6px 10px",
  borderRadius: 6,
  background: "#fff",
  cursor: "pointer"
};